export default __webpack_public_path__ + "static/media/seoFriendly.1f117b89.md";